"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 接口模块
var _default = exports.default = {
  getMenuList: function getMenuList(data) {
    return (0, _request.default)({
      url: '/protected/menu/list',
      method: 'post',
      data: data
    });
  },
  getMenuDetail: function getMenuDetail(id) {
    return (0, _request.default)({
      url: '/protected/menu/query/' + id,
      method: 'get'
    });
  },
  saveMenu: function saveMenu(data) {
    return (0, _request.default)({
      url: '/protected/menu/save',
      method: 'post',
      data: data
    });
  },
  deleteMenu: function deleteMenu(data) {
    return (0, _request.default)({
      url: '/protected/menu/delete',
      method: 'post',
      data: data
    });
  },
  enableMenu: function enableMenu(id) {
    return (0, _request.default)({
      url: '/protected/menu/enable/' + id,
      method: 'get'
    });
  },
  disableMenu: function disableMenu(id) {
    return (0, _request.default)({
      url: '/protected/menu/disable/' + id,
      method: 'get'
    });
  }
};